export const MENTAL_CLARITY_GUIDE = {
  path: "/mental-clarity",
  url: "https://ahavibes.xyz/mental-clarity",
  headline:
    "The Complete Guide to Mental Clarity: How to Think Clearly, Respond Confidently, and Make Better Decisions",
  description:
    "Learn what mental clarity is, why it matters, how stress affects it, and daily habits to think clearly, respond confidently, and make better decisions.",
  sections: [
    {
      id: "introduction",
      position: 1,
      name: "Introduction",
      description: "What mental clarity is and why this guide matters.",
    },
    {
      id: "what-is-mental-clarity",
      position: 2,
      name: "What Is Mental Clarity?",
      description: "Definition, facts vs. stories, responding vs. reacting.",
    },
    {
      id: "why-mental-clarity-matters",
      position: 3,
      name: "Why Mental Clarity Matters",
      description: "Hidden costs of mental clutter and why leaders need clarity.",
    },
    {
      id: "signs-you-lack-mental-clarity",
      position: 4,
      name: "Signs You Lack Mental Clarity",
      description: "Mental, emotional, behavioral, and communication signs.",
    },
    {
      id: "mental-clarity-vs-mindfulness",
      position: 5,
      name: "Mental Clarity vs. Mindfulness",
      description: "How awareness and structured thinking differ.",
    },
    {
      id: "daily-habits",
      position: 6,
      name: "Daily Habits That Improve Mental Clarity",
      description: "Self-awareness, questioning thoughts, early overload signals, thinking space.",
    },
    {
      id: "stress-reduces-clarity",
      position: 7,
      name: "How Stress Reduces Mental Clarity",
      description: "Why stress narrows thinking and how to recognize reactive state.",
    },
    {
      id: "mental-clarity-at-work",
      position: 8,
      name: "Mental Clarity at Work",
      description: "Professional performance and introvert communication.",
    },
    {
      id: "a-calm-mindset",
      position: 9,
      name: "A Calm Mindset",
      description: "Composed engagement under pressure.",
    },
    {
      id: "mental-clarity-for-leaders",
      position: 10,
      name: "Mental Clarity for Leaders",
      description: "Self-leadership and decision quality.",
    },
    {
      id: "ahavibes-perspective",
      position: 11,
      name: "The Ahavibes Perspective",
      description: "Mental clarity as a leadership capability in the AI age.",
    },
  ],
};
